import { makeProvider } from 'react-provider-maker';
import { i18nDefault } from '../../i18n/default';

export const { Provider: TranslatorProvider, useProvider: useTranslator } = makeProvider(
  () => {
    return i18nDefault;
  }
);
